import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import Layout from "./Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFileUpload,
  faUpload,
  faImage,
  faFilePdf,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";

import "react-awesome-lightbox/build/style.css";

class Ambitos extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      ente: "",
      dirgral: "",
      dir: "",
      depto: "",
      formatos: "",
      dinamica: "",
      nivel: "",
      indice: "",
      responsable: "",
      desc_responsable: "",
      nom_firmante1: "",
      desc_firmante1: "",
      nom_firmante2: "",
      desc_firmante2: "",
      nom_firmante3: "",
      desc_firmante3: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      ambitos: [], // Listado de elementos para la tabla
      loading: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  };

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Ambito?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ ambitos: res.data, loading: false });
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        1 +
        "/ambito/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModalDocumentos = () => {
    this.setState({ modalDocumentos: true });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  onFileChange = (event) => {
    this.setState({
      frm_archivo: event.target.files[0],
    });
  };

  sube_documento = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    let datosFormulario = new FormData();
    datosFormulario.append("archivo", this.state.frm_archivo);
    datosFormulario.append("descripcion", this.state.frm_descripcion_doc);
    datosFormulario.append("tipo", "jpg");
    datosFormulario.append("anexo_cve", "ambito");
    datosFormulario.append("fx_id", this.state.id);
    datosFormulario.append("ambito_id", this.state.ambito_id);
    datosFormulario.append("usuario_id", this.state.usuario_id);
    datosFormulario.append("api_token", localStorage.api_token);

    let config = {};
    axios
      .post(
        "http://143.198.191.211/api/Documento/",
        datosFormulario,
        config
      )
      .then((res) => {
        this.closeModalDocumentos();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      ente: "",
      dirgral: "",
      dir: "",
      depto: "",
      formatos: "",
      dinamica: "",
      nivel: "",
      indice: "",
      responsable: "",
      desc_responsable: "",
      nom_firmante1: "",
      desc_firmante1: "",
      nom_firmante2: "",
      desc_firmante2: "",
      nom_firmante3: "",
      desc_firmante3: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      ente: row.ente,
      dirgral: row.dirgral,
      dir: row.dir,
      depto: row.depto,
      formatos: row.formatos,
      dinamica: row.dinamica,
      nivel: row.nivel,
      indice: row.indice,
      responsable: row.responsable,
      desc_responsable: row.desc_responsable,
      nom_firmante1: row.nom_firmante1,
      desc_firmante1: row.desc_firmante1,
      nom_firmante2: row.nom_firmante2,
      desc_firmante2: row.desc_firmante2,
      nom_firmante3: row.nom_firmante3,
      desc_firmante3: row.desc_firmante3,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      ente: row.ente,
      dirgral: row.dirgral,
      dir: row.dir,
      depto: row.depto,
      formatos: row.formatos,
      dinamica: row.dinamica,
      nivel: row.nivel,
      indice: row.indice,
      responsable: row.responsable,
      desc_responsable: row.desc_responsable,
      nom_firmante1: row.nom_firmante1,
      desc_firmante1: row.desc_firmante1,
      nom_firmante2: row.nom_firmante2,
      desc_firmante2: row.desc_firmante2,
      nom_firmante3: row.nom_firmante3,
      desc_firmante3: row.desc_firmante3,
    });
  };

  ModalDocumentos = (row) => {
    this.showModalDocumentos();
    this.setState({
      modalLabel: "Documentos",
      variante: "warning",
      modalAccion: "document",
      modalTitle: "Documentos",
      id: row.id,
      ente: row.ente,
      dirgral: row.dirgral,
      dir: row.dir,
      depto: row.depto,
      formatos: row.formatos,
      dinamica: row.dinamica,
      nivel: row.nivel,
      indice: row.indice,
      responsable: row.responsable,
      desc_responsable: row.desc_responsable,
      nom_firmante1: row.nom_firmante1,
      desc_firmante1: row.desc_firmante1,
      nom_firmante2: row.nom_firmante2,
      desc_firmante2: row.desc_firmante2,
      nom_firmante3: row.nom_firmante3,
      desc_firmante3: row.desc_firmante3,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      ente: row.ente,
      dirgral: row.dirgral,
      dir: row.dir,
      depto: row.depto,
      formatos: row.formatos,
      dinamica: row.dinamica,
      nivel: row.nivel,
      indice: row.indice,
      responsable: row.responsable,
      desc_responsable: row.desc_responsable,
      nom_firmante1: row.nom_firmante1,
      desc_firmante1: row.desc_firmante1,
      nom_firmante2: row.nom_firmante2,
      desc_firmante2: row.desc_firmante2,
      nom_firmante3: row.nom_firmante3,
      desc_firmante3: row.desc_firmante3,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      ente: this.state.ente,
      dirgral: this.state.dirgral,
      dir: this.state.dir,
      depto: this.state.depto,
      formatos: this.state.formatos,
      dinamica: this.state.dinamica,
      nivel: this.state.nivel,
      indice: this.state.indice,
      responsable: this.state.responsable,
      desc_responsable: this.state.desc_responsable,
      nom_firmante1: this.state.nom_firmante1,
      desc_firmante1: this.state.desc_firmante1,
      nom_firmante2: this.state.nom_firmante2,
      desc_firmante2: this.state.desc_firmante2,
      nom_firmante3: this.state.nom_firmante3,
      desc_firmante3: this.state.desc_firmante3,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .post("http://143.198.191.211/api/Ambito", data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      ente: this.state.ente,
      dirgral: this.state.dirgral,
      dir: this.state.dir,
      depto: this.state.depto,
      formatos: this.state.formatos,
      dinamica: this.state.dinamica,
      nivel: this.state.nivel,
      indice: this.state.indice,
      responsable: this.state.responsable,
      desc_responsable: this.state.desc_responsable,
      nom_firmante1: this.state.nom_firmante1,
      desc_firmante1: this.state.desc_firmante1,
      nom_firmante2: this.state.nom_firmante2,
      desc_firmante2: this.state.desc_firmante2,
      nom_firmante3: this.state.nom_firmante3,
      desc_firmante3: this.state.desc_firmante3,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put(
        "http://143.198.191.211/api/Ambito/" + this.state.id,
        data,
        config
      )
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/Ambito/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeEnte = (e) => {
    this.setState({ ente: e.target.value });
  };

  onChangeDirgral = (e) => {
    this.setState({ dirgral: e.target.value });
  };

  onChangeDir = (e) => {
    this.setState({ dir: e.target.value });
  };

  onChangeDepto = (e) => {
    this.setState({ depto: e.target.value });
  };

  onChangeFormatos = (e) => {
    this.setState({ formatos: e.target.value });
  };

  onChangeDinamica = (e) => {
    this.setState({ dinamica: e.target.value });
  };

  onChangeNivel = (e) => {
    this.setState({ nivel: e.target.value });
  };

  onChangeIndice = (e) => {
    this.setState({ indice: e.target.value });
  };

  onChangeResponsable = (e) => {
    this.setState({ responsable: e.target.value });
  };

  onChangeDescResponsable = (e) => {
    this.setState({ desc_responsable: e.target.value });
  };

  onChangeNomFirmante1 = (e) => {
    this.setState({ nom_firmante1: e.target.value });
  };

  onChangeDescFirmante1 = (e) => {
    this.setState({ desc_firmante1: e.target.value });
  };
  onChangeNomFirmante2 = (e) => {
    this.setState({ nom_firmante2: e.target.value });
  };
  onChangeDescFirmante2 = (e) => {
    this.setState({ desc_firmante2: e.target.value });
  };
  onChangeNomFirmante3 = (e) => {
    this.setState({ nom_firmante3: e.target.value });
  };
  onChangeDescFirmante3 = (e) => {
    this.setState({ desc_firmante3: e.target.value });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        headerStyle: () => {
          return {
            width: "100px",
            zIndex: "98",
          };
        },
      },
      {
        dataField: "ente",
        text: "Ente",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "dirgral",
        text: "Dirgral",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "dir",
        text: "Dir",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "depto",
        text: "Depto",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "formatos",
        text: "Anexos",
        sort: true,
        headerStyle: () => {
          return { width: "270px" };
        },
      },
      {
        dataField: "nivel",
        text: "Nivel",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "indice",
        text: "Indice",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "responsable",
        text: "Responsable",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "desc_responsable",
        text: "Descripción Responsable",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "nom_firmante1",
        text: "Firmante 1",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "desc_firmante1",
        text: "Descripción Firmante 1",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },

      {
        dataField: "nom_firmante2",
        text: "Firmante 2",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "desc_firmante2",
        text: "Descripción Firmante 2",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "nom_firmante3",
        text: "Firmante 3",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },
      {
        dataField: "desc_firmante3",
        text: "Descripción Firmante 3",
        sort: true,
        headerStyle: () => {
          return { width: "170px" };
        },
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        headerStyle: () => {
          return {
            width: "115px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">Catálogo de Ambitos</h3>
              <br />
              <small className="text-muted">
                Registre Elimine o Modifique Ambitos, estos elementos estan
                ligados a los usuarios de el sistema.
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.ambitos}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <button
                          className="btn btn-primary"
                          onClick={this.ModalNuevo}
                          data-tip="Nuevo"
                        >
                          <FontAwesomeIcon icon={faPlus} /> Nuevo
                        </button>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              {" "}
              <Col xs="4">
                <Form.Label>
                  Ente:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ente"
                  value={this.state.ente}
                  onChange={this.onChangeEnte}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Dirgral:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="dirgral"
                  value={this.state.dirgral || ""}
                  onChange={this.onChangeDirgral}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Dir:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="dir"
                  value={this.state.dir || ""}
                  onChange={this.onChangeDir}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Depto:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="depto"
                  value={this.state.depto || ""}
                  onChange={this.onChangeDepto}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Anexos:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="formatos"
                  value={this.state.formatos || ""}
                  onChange={this.onChangeFormatos}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Dinamica:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="dinamica"
                  value={this.state.dinamica || ""}
                  onChange={this.onChangeDinamica}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Nivel:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="nivel"
                  value={this.state.nivel || ""}
                  onChange={this.onChangeNivel}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Indice:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="indice"
                  value={this.state.indice || ""}
                  onChange={this.onChangeIndice}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Responsable:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="responsable"
                  value={this.state.responsable || ""}
                  onChange={this.onChangeResponsable}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Descripción Responsable:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="desc_responsable"
                  value={this.state.desc_responsable || ""}
                  onChange={this.onChangeDescResponsable}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Firmante 1:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nom_firmante1"
                  key="nom_firmante1"
                  value={this.state.nom_firmante1 || ""}
                  onChange={this.onChangeNomFirmante1}
                />
              </Col>
              <Col xs="4">
                {" "}
                <Form.Label>
                  Firmante 2:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nom_firmante2"
                  key="nom_firmante2"
                  value={this.state.nom_firmante2 || ""}
                  onChange={this.onChangeNomFirmante2}
                />
              </Col>
              <Col xs="4">
                {" "}
                <Form.Label>
                  Firmante 3:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nom_firmante3"
                  key="nom_firmante3"
                  value={this.state.nom_firmante3 || ""}
                  onChange={this.onChangeNomFirmante3}
                />
              </Col>
              <Col xs="4">
                {" "}
                <Form.Label>
                  Descripción 1:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="desc_firmante1"
                  value={this.state.desc_firmante1 || ""}
                  onChange={this.onChangeDescFirmante1}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Descripción 2:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="desc_firmante2"
                  value={this.state.desc_firmante2 || ""}
                  onChange={this.onChangeDescFirmante2}
                />
              </Col>
              <Col xs="4">
                <Form.Label>
                  Descripción 3:
                  <OverlayTrigger
                    trigger="focus"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({
                          input_tooltip: "Este campo no tiene ayuda.",
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="desc_firmante3"
                  value={this.state.desc_firmante3 || ""}
                  onChange={this.onChangeDescFirmante3}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button
              variant={this.state.variante}
              onClick={this.ejecutar}
              disabled={this.state.loading}
            >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={this.ejecutar}
              disabled={this.state.loading}
            >
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ente:
                    </Col>
                    <Col xs={10}>{this.state.ente}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Dirgral:
                    </Col>
                    <Col xs={10}>{this.state.dirgral}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Dir:
                    </Col>
                    <Col xs={10}>{this.state.dir}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Depto:
                    </Col>
                    <Col xs={10}>{this.state.depto}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Anexos:
                    </Col>
                    <Col xs={10}>{this.state.formatos}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Dinamica:
                    </Col>
                    <Col xs={10}>{this.state.dinamica}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nivel:
                    </Col>
                    <Col xs={10}>{this.state.nivel}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Indice:
                    </Col>
                    <Col xs={10}>{this.state.indice}</Col>
                  </Row>

                  <Row>
                    <Col xs={2} className="text-muted">
                      Firmante 1:
                    </Col>
                    <Col xs={10}>{this.state.nom_firmante1}</Col>
                  </Row>

                  <Row>
                    <Col xs={2} className="text-muted">
                      Firmante 2:
                    </Col>
                    <Col xs={10}>{this.state.nom_firmante2}</Col>
                  </Row>

                  <Row>
                    <Col xs={2} className="text-muted">
                      Firmante 3:
                    </Col>
                    <Col xs={10}>{this.state.nom_firmante3}</Col>
                  </Row>

                  <Row>
                    <Col xs={2} className="text-muted">
                      Descripción 1:
                    </Col>
                    <Col xs={10}>{this.state.desc_firmante1}</Col>
                  </Row>

                  <Row>
                    <Col xs={2} className="text-muted">
                      Descripción 2:
                    </Col>
                    <Col xs={10}>{this.state.desc_firmante2}</Col>
                  </Row>

                  <Row>
                    <Col xs={2} className="text-muted">
                      Descripción 3:
                    </Col>
                    <Col xs={10}>{this.state.desc_firmante3}</Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para Documentos
          show={this.state.modalDocumentos}
          onHide={this.closeModalDocumentos}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Documentos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body>
              <Form.Row>
                <Col xs="12">
                  <Form.Label>
                    Descripcion del Archivo:
                    <OverlayTrigger
                      trigger="focus"
                      placement="right"
                      overlay={popover}
                    >
                      <Button
                        variant="light"
                        onClick={(e) => {
                          this.setState({
                            input_tooltip:
                              "Ingrese un texto descriptivo del documento que se va a subir.",
                          });
                        }}
                      >
                        <FontAwesomeIcon icon={faQuestionCircle} />
                      </Button>
                    </OverlayTrigger>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="frm_descripcion_doc"
                    onChange={this.onChangefrm_descripcion_doc}
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col xs="12">
                  <br />
                  <label htmlFor="file-upload" className="custom-file-upload">
                    <FontAwesomeIcon icon={faUpload} /> Seleccionar Archivo PDF
                    o Imagen
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    onChange={this.onFileChange}
                    accept="image/png, image/jpeg, application/pdf"
                    className="btnSubir"
                  />
                </Col>
              </Form.Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalDocumentos}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.sube_documento}>
              Guardar Documento
            </Button>
          </Modal.Footer>
        </Modal>

        <ReactTooltip />
      </Layout>
    );
  }
}

export default Ambitos;
